<template>
  <div>
    <v-text-field
      :label="
        label != 'フォームID' ? label : searchPage ? 'ページID' : 'フォームID'
      "
      v-model="value"
      @click="open"
      :hint="hint"
      :persistent-hint="hint != ''"
      :rules="[required ? validation.required : true]"
    ></v-text-field>
    <!-- モーダル部分  --->
    <v-dialog v-model="dialog" max-height="700px" max-width="1200px">
      <v-card>
        <v-card-actions>
          <v-container>
            <div class="text-center">
              <v-form ref="form" v-model="valid" @submit.prevent>
                <!-- ページ選択部分  --->
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      :label="
                        label != 'フォームID'
                          ? label
                          : searchPage
                          ? 'ページID'
                          : 'フォームID'
                      "
                      v-model="id"
                      :rules="[validation.required]"
                      :hint="hint"
                      :persistent-hint="hint != ''"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :cols="searchPage ? '12' : '8'">
                    ページ一覧
                    <v-virtual-scroll
                      :items="pages"
                      :height="50 * pageCount"
                      :width="pageWidth"
                      item-height="50"
                      :item-width="pageWidth"
                      max-height="350"
                      outlined
                    >
                      <template v-slot:default="{ item }">
                        <v-list-item class="ma-0 mp-0">
                          <v-btn
                            color="blue lighten-5"
                            @click="clickPage(item)"
                            :disabled="disableCheck('page', item)"
                          >
                            {{ item.ID }}| {{ item.title }}
                          </v-btn>
                        </v-list-item>
                      </template>
                    </v-virtual-scroll>
                  </v-col>
                </v-row>
                <!-- ページモーダル  -->
                <v-dialog
                  v-model="formDialog"
                  height="700px"
                  width="1200px"
                  max-height="700px"
                  max-width="1200px"
                  @click:outside="close"
                >
                  <v-card>
                    <v-row no-gutters>
                      <v-col cols="4" class="ml-2">
                        <v-text-field
                          :label="
                            label != 'フォームID'
                              ? label
                              : searchPage
                              ? 'ページID'
                              : 'フォームID'
                          "
                          v-model="id"
                          :rules="[validation.required]"
                          :hint="hint"
                          :persistent-hint="hint != ''"
                        ></v-text-field>
                      </v-col>
                      <hr />
                    </v-row>
                    <div v-for="i of rows" :key="i" class="ma-0">
                      <v-row no-gutters>
                        <p>{{ i }}</p>
                        <div v-for="j of cols" :key="j">
                          <v-col
                            :cols="
                              forms[j - 1][i - 1].ID == 0
                                ? 1
                                : String(Math.floor(12 / cols))
                            "
                            class="ma-0"
                          >
                            <v-btn
                              color="blue lighten-5"
                              :max-width="
                                forms[j - 1][i - 1].ID == 0 ? '10' : 200
                              "
                              :width="forms[j - 1][i - 1].ID == 0 ? '10' : 200"
                              :disabled="forms[j - 1][i - 1].ID == 0"
                              @click="clickForm(forms[j - 1][i - 1])"
                            >
                              {{ forms[j - 1][i - 1].ID }}:{{
                                forms[j - 1][i - 1].Label
                              }}
                            </v-btn>
                          </v-col>
                        </div>
                      </v-row>
                      <hr />
                    </div>
                  </v-card>
                </v-dialog>
                <!--- --------------->
              </v-form>
            </div>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
export default {
  components: {},
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: { required: true },
    label: { type: String, default: "フォームID" },
    required: { type: Boolean, default: false },
    hint: { type: String, default: "" },
    searchPage: { type: Boolean, default: false },
    samePage: { type: Boolean, default: false },
    initPageID: { type: Number, default: 0 },
  },
  computed: {
    id: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("change", String(value));
      },
    },
  },
  /*
  watch: {
    value: {
      handler(value) {
        console.log("change", value);
        this.$emit("change", String(value));
      },
    },
  },
  */
  data() {
    return {
      validation: {
        required: (value) => !!value || "必須項目です",
      },
      valid: true,
      dialog: false,
      rows: 0,
      cols: 0,
      //ページ関連
      pageID: 0,
      pages: [],
      pageWidth: this.searchPage ? "800" : "300",
      pageCount: 0,
      //フォーム関連
      formDialog: false,
      forms: [],
      formWidth: "400",
      formCount: 0,
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.pages = await api.getPage();
      this.pageCount = this.pages.length;
    },
    async open() {
      this.dialog = true;
      //特定ページ限定
      if (this.samePage) {
        if (this.initPageID != 0) {
          this.pageID = this.initPageID;
        } else {
          this.pageID = Number(this.$route.params.page_id);
        }
        let input = this.pages.filter((item) => item.ID == this.pageID);
        if (input.length == 1) {
          await this.clickPage(input[0]);
        }
      }
    },
    close() {
      this.dialog = false;
      this.formDialog = false;
    },
    disableCheck(type, item) {
      if (type == "page") {
        switch (item.page_template_ID) {
          case 2:
          case 6:
          case 7:
            return false;
        }
      } else {
        return true;
      }
      return true;
    },
    async clickPage(item) {
      //ページIDの設定
      if (this.searchPage) {
        this.id = item.ID;
        this.close();
        return;
      } else {
        let data = {
          customerID: Number(this.$route.params.id),
          pageID: Number(item.ID),
        };
        //API通信
        const response = await api.GetForm(data);
        this.forms = response.data;
        this.rows = this.forms[0].length;
        this.cols = this.forms.length;
        this.formCount = this.forms[0].length;
        this.formDialog = true;
      }
    },
    async clickForm(item) {
      //ページIDの設定
      this.id = item.ID;
      this.close();
    },
  },
};
</script>
